var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnmute = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.471 18.841 3.651-2.433c1.597-1.065 3.736.08 3.736 1.999v10.467c0 1.919-2.139 3.064-3.736 1.999l-3.65-2.433h-1.673c-2.65 0-4.799-2.149-4.799-4.799 0-2.651 2.149-4.8 4.799-4.8zm5.243-.434c0-.206-.231-.33-.403-.215l-3.727 2.485c-.072.048-.115.128-.115.215v5.497c0 .086.043.167.115.215l3.727 2.485c.172.115.403-.009.403-.215zm6.096 1.575c-.408-.407-1.069-.407-1.476 0-.408.408-.408 1.069 0 1.476l2.411 2.411-2.41 2.41c-.407.408-.407 1.069 0 1.476.408.408 1.069.408 1.476 0l2.41-2.41 2.41 2.41c.408.408 1.068.408 1.476 0 .407-.407.407-1.068 0-1.476l-2.41-2.41 2.411-2.411c.408-.407.408-1.068 0-1.476-.407-.407-1.068-.407-1.476 0l-2.411 2.412zm-13.018 1.004c-1.463.004-2.647 1.191-2.647 2.655 0 1.463 1.184 2.65 2.647 2.654z",
    fill: "#fff",
    transform: "matrix(1.82797 0 0 1.82797 -16.5936 -19.214)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnmute);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unmute.4486650a4b41a578f317ec42640d2248.svg";